// @flow

import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { colors } from '@peachjar/components';

import HorizontalRule from './HorizontalRule';
import DiscountSection from './DiscountSection';
import { storeStripeAmount } from '../../../../onboarding/onboarding.duck';

const { silver, slate } = colors;

const styles = {
  orderSummary: {
    title: {
      color: slate,
    },
    schools: {
      paddingTop: '1.5rem',
    },
    horizontalRule: {
      height: '1px',
      backgroundColor: silver,
      margin: '1rem 0',
    },
  },
};

type Props = {|
  +numberOfSchools: number,
  +discountCode: string,
  +discountRate: number,
  +peachjarProduct: string,
  +startUpFeePerSchool: number,
  +prediscountAmount: number,
  +totalAmount: number,
|};

class OrderSummary extends Component<Props> {
  componentDidMount() {
    this.props.storeStripeAmount(this.props.totalAmount);
  }

  render() {
    const {
      numberOfSchools,
      discountCode,
      discountRate,
      peachjarProduct,
      startUpFeePerSchool,
      prediscountAmount,
      totalAmount,
    } = this.props;

    return (
      <div
        style={{ padding: '0.75rem 0 0 1.5rem' }}
        className="flex-auto pj-font-size-02"
      >
        <span style={styles.orderSummary.title}>ORDER SUMMARY</span>
        <div
          style={styles.orderSummary.schools}
          className="layout-row layout-align-space-between-center"
        >
          <div className="layout-row layout-align-center-center">
            <span>{peachjarProduct}</span>
          </div>
          <span data-testid="info-numberOfSchools">
            {numberOfSchools} {numberOfSchools > 1 ? 'Schools' : 'School'}
          </span>
        </div>

        {discountCode &&
          discountRate && (
            <DiscountSection
              {...{
                discountCode,
                discountRate,
                startUpFeePerSchool,
                prediscountAmount,
              }}
            />
          )}

        <HorizontalRule margin="1rem 0" />

        <div className="layout-row layout-align-space-between">
          <span>Total</span>
          <span
            data-testid="info-totalAmount"
            className="pj-font-size-03 pj-font-weight-bold"
          >
            ${totalAmount}
          </span>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      storeStripeAmount,
    },
    dispatch
  );

export default connect(
  null,
  mapDispatchToProps
)(OrderSummary);



// WEBPACK FOOTER //
// ./src/Onboarding/Registration/onboarding/containers/Payment/components/OrderSummary.jsx